import React, { useState } from "react";
import { FaArrowLeft, FaUpload, FaCopy, FaCheck } from "react-icons/fa";
import "./easypaisa-manual.css";
import UploadReceiptModal from "./UploadReceiptModal";

const EasyPaisaManual = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [copied, setCopied] = useState({
    accountNumber: false,
    accountName: false
  });

  const handleSubmit = (formData) => {
    console.log("Uploaded Receipt Data:", formData);
    // TODO: Backend API Call (Send Data to Server)
  };

  const copyToClipboard = (text, field) => {
    navigator.clipboard.writeText(text);
    setCopied({...copied, [field]: true});
    setTimeout(() => setCopied({...copied, [field]: false}), 2000);
  };

  const paymentDetails = {
    accountNumber: "03160010434",
    accountName: "Kiran maz",
    instructions: [
      "Send exact amount from your EasyPaisa account",
      "Include your username in payment reference",
      "Upload receipt immediately after payment",
      "Coins will be added within 15 minutes"
    ]
  };

  return (
    <div className="epm-container">
      <div className="epm-glass-card">
        {/* Header */}
        <div className="epm-header">
          <button className="epm-back-btn" onClick={() => window.history.back()}>
            <FaArrowLeft className="icon" /> Back
          </button>
          <h1 className="epm-title">EasyPaisa Manual Payment</h1>
          <div className="epm-security-badge">
            <span className="epm-secure-icon">🔒</span> SECURE TRANSACTION
          </div>
        </div>

        {/* Payment Instructions */}
        <div className="epm-instructions">
          <p className="epm-description">
            Transfer your payment using the details below and upload the receipt for verification.
          </p>
          
          <div className="epm-details-card">
            <h3 className="epm-details-title">Payment Details</h3>
            
            <div className="epm-detail-row">
              <span className="epm-detail-label">Account Number:</span>
              <div className="epm-detail-value">
                {paymentDetails.accountNumber}
                <button 
                  className="epm-copy-btn" 
                  onClick={() => copyToClipboard(paymentDetails.accountNumber, 'accountNumber')}
                >
                  {copied.accountNumber ? <FaCheck /> : <FaCopy />}
                </button>
              </div>
            </div>
            
            <div className="epm-detail-row">
              <span className="epm-detail-label">Account Name:</span>
              <div className="epm-detail-value">
                {paymentDetails.accountName}
                <button 
                  className="epm-copy-btn" 
                  onClick={() => copyToClipboard(paymentDetails.accountName, 'accountName')}
                >
                  {copied.accountName ? <FaCheck /> : <FaCopy />}
                </button>
              </div>
            </div>
          </div>

          <div className="epm-instructions-list">
            <h3 className="epm-instructions-title">Important Instructions</h3>
            <ul>
              {paymentDetails.instructions.map((instruction, index) => (
                <li key={index} className="epm-instruction-item">
                  <span className="epm-instruction-icon">•</span> {instruction}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Action Button */}
        <button 
          className="epm-upload-btn" 
          onClick={() => setIsModalOpen(true)}
        >
          <FaUpload className="icon" /> Upload Payment Receipt
        </button>
      </div>

      {/* Upload Receipt Modal */}
      <UploadReceiptModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
        onSubmit={handleSubmit} 
      />
    </div>
  );
};

export default EasyPaisaManual;